module.exports = {"1":"Muy malo","2":"Malo","3":"Bueno","4":"Muy bueno","5":"Excelente","1.5":"Muy malo","2.5":"Malo","3.5":"Bueno","4.5":"Excelente"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/es-ES/star-ratings.json
// module id = 1299
// module chunks = 0